module.exports = __webpack_public_path__ + "media/images/common/ico_04-470db58374ed8ba9b2ab4b985ce38c3d.png";